import { atom } from 'recoil'
import { recoilPersist } from 'recoil-persist'
const { persistAtom } = recoilPersist()

export const colorSchemeAtom = atom<'light' | 'dark'>({
  key: 'theme/ColorSchemeAtom',
  default: 'light',
  effects_UNSTABLE: [persistAtom],
});
